(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["collection-products"] && !Shopify.designMode) return;
  try {
    class TrCollectionProducts extends HTMLElement {
    #list = null;
    #progress = null;
    #bar = null;
    #controller = null;
    #observer = null;

    connectedCallback() {
      this.#list = this.querySelector('[data-ref="collectionProductsList"]');
      this.#progress = this.querySelector('[data-ref="collectionProductsProgress"]');
      this.#bar = this.querySelector('[data-ref="collectionProductsProgressBar"]');
      if (this.#list === null || this.#bar === null) return;

      this.#controller = new AbortController();
      this.#list.addEventListener('scroll', this.#sync, { signal: this.#controller.signal, passive: true });

      if (window.ResizeObserver !== undefined) {
        this.#observer = new ResizeObserver(this.#sync);
        this.#observer.observe(this.#list);
      }

      this.#sync();
    }

    disconnectedCallback() {
      this.#controller?.abort();
      this.#observer?.disconnect();
    }

    /* Deux nombres entre 0 et 1 posés en variables : la part visible et sa position. */
    #sync = () => {
      const { scrollWidth, clientWidth } = this.#list;
      const scrollable = scrollWidth > clientWidth + 1;
      this.#progress.hidden = scrollable === false;
      if (scrollable === false) return;

      const part = clientWidth / scrollWidth;
      const pos = Math.abs(this.#list.scrollLeft) / scrollWidth;
      this.#bar.style.setProperty('--tr-cp-progress-part', part.toFixed(4));
      this.#bar.style.setProperty('--tr-cp-progress-pos', (pos / part).toFixed(4));
    };
  }

  if (customElements.get('tr-collection-products') === undefined) {
    customElements.define('tr-collection-products', TrCollectionProducts);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-inventory"] && !Shopify.designMode) return;
  try {
    /* tr-product-inventory — suit la variante courante (états pré-calculés côté Liquid, jamais inventés). */
  class TrProductInventory extends HTMLElement {
    #controller = null;
    #states = {};

    connectedCallback() {
      const data = this.querySelector('[data-ref="inventoryStates"]');
      try {
        this.#states = data === null ? {} : JSON.parse(data.textContent);
      } catch {
        this.#states = {};
      }

      this.#controller = new AbortController();
      document.addEventListener('tr:variant-change', this.#onVariantChange, { signal: this.#controller.signal });
    }

    disconnectedCallback() {
      this.#controller?.abort();
      this.#controller = null;
    }

    #onVariantChange = (event) => {
      const detail = event.detail;
      if (detail === undefined) return;

      const productId = this.dataset.productId;
      if (detail.productId !== null && detail.productId !== undefined && String(detail.productId) !== productId) return;

      const entry = this.#states[String(detail.variantId)];
      if (entry === undefined) return;

      const state = entry.state ?? 'in-stock';
      const qty = Number(entry.qty) || 0;

      this.classList.remove('tr-inv--in-stock', 'tr-inv--low', 'tr-inv--out');
      this.classList.add(`tr-inv--${state}`);
      this.dataset.quantity = String(qty);

      const text = this.querySelector('[data-ref="inventoryText"]');
      if (text !== null) {
        if (state === 'out') text.textContent = this.dataset.textOut ?? '';
        else if (state === 'low') text.textContent = (this.dataset.textLow ?? '').replace('[quantité]', String(qty));
        else text.textContent = this.dataset.textIn ?? '';
      }

      const track = this.querySelector('[data-ref="inventoryTrack"]');
      const fill = this.querySelector('[data-ref="inventoryFill"]');
      if (track !== null) track.hidden = state !== 'low';
      if (fill !== null) {
        const max = Number(this.dataset.maxStock) || 0;
        const percent = max > 0 && qty > 0 ? Math.min(100, Math.round((qty * 100) / max)) : 0;
        fill.style.inlineSize = `${percent}%`;
      }
    };
  }

  if (customElements.get('tr-product-inventory') === undefined) {
    customElements.define('tr-product-inventory', TrProductInventory);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-price"] && !Shopify.designMode) return;
  try {
    /*
   * tr-product-price — le prix affiché.
   *
   * Deux sources selon `data-follow-total` :
   *   • false → prix unitaire de la variante (`tr:variant-change`, filtré sur le produit) ;
   *   • true  → TOTAL de la sélection (quantité × palier × plan × options), lu
   *     sur <tr-product-form> à chaque `tr:form-change`. Le prix à l'écran ne
   *     peut alors plus diverger du prix du bouton (05·R7, reste de P0-01).
   *
   * Honnêteté (charte) : le prix barré n'apparaît QUE face à une référence
   * réelle et supérieure — `compare_at_price` de la variante, ou le prix plein
   * quand une remise réellement configurée abaisse le total. Dès que la
   * sélection compte plusieurs lignes (bundle, cadeau, cross-sell), aucune
   * référence n'est opposable : barré et badge d'économie sont masqués.
   */
  class TrProductPrice extends HTMLElement {
    #controller = null;
    #form = null;
    #follow = false;
    #unitPrice = 0;
    #unitCompare = 0;
    #available = true;
    #total = null;
    #quantity = 1;
    #multi = false;

    connectedCallback() {
      this.#controller = new AbortController();
      const { signal } = this.#controller;

      this.#unitPrice = Number(this.dataset.price) || 0;
      this.#unitCompare = Number(this.dataset.compare) || 0;
      this.#available = this.dataset.available !== 'false';

      document.addEventListener('tr:variant-change', this.#onVariantChange, { signal });

      if (this.dataset.followTotal !== 'true') return;

      this.#form =
        this.closest('tr-product-form') ??
        document.querySelector(`tr-product-form[data-product-id="${this.dataset.productId}"]`);

      if (this.#form === null) return;

      this.#follow = true;
      this.#form.addEventListener('tr:form-change', this.#onFormChange, { signal });

      /* Le formulaire a pu être promu — et émettre son premier `tr:form-change` —
         avant ce bloc : première lecture directe à la frame suivante. */
      requestAnimationFrame(this.#syncFromForm);
    }

    disconnectedCallback() {
      this.#controller?.abort();
      this.#controller = null;
      this.#form = null;
      this.#follow = false;
    }

    #money(cents) {
      const format = window.Traction?.formatMoney;
      return typeof format === 'function' ? format(cents) : String((Number(cents) || 0) / 100);
    }

    #unitData = null;

    #readUnitData() {
      if (this.#unitData !== null) return this.#unitData;

      this.#unitData = {};
      const data = this.querySelector('[data-ref="unitPriceData"]');
      if (data === null) return this.#unitData;

      try {
        const parsed = JSON.parse(data.textContent);
        if (parsed !== null && typeof parsed === 'object') this.#unitData = parsed;
      } catch {
        /* map vide : le prix unitaire Liquid reste affiché tel quel */
      }

      return this.#unitData;
    }

    /** Prix unitaire (« 9,90 € / 100 g ») rafraîchi au changement de variante. */
    #updateUnitPrice(variantId) {
      const target = this.querySelector('[data-ref="priceUnit"]');
      if (target === null) return;

      const entry = this.#readUnitData()[String(variantId)];

      if (entry === undefined || entry === null || Number(entry.unit_price) <= 0) {
        target.hidden = true;
        target.textContent = '';
        return;
      }

      const reference = Number(entry.reference_value) || 1;
      const value = reference === 1 ? '' : String(reference);

      target.textContent = `${this.#money(Number(entry.unit_price))} / ${value}${entry.reference_unit ?? ''}`;
      target.hidden = false;
    }

    #onVariantChange = (event) => {
      const detail = event.detail;
      if (detail === undefined || detail.variant === undefined) return;

      const productId = this.dataset.productId;
      if (detail.productId !== null && detail.productId !== undefined && String(detail.productId) !== productId) return;

      this.#unitPrice = Number(detail.price) || 0;
      this.#unitCompare = Number(detail.compareAtPrice) || 0;
      this.#available = detail.available !== false;

      this.dataset.variantId = String(detail.variantId);
      this.dataset.price = String(this.#unitPrice);
      this.dataset.compare = String(this.#unitCompare);

      this.#updateUnitPrice(detail.variantId);
      this.#render();
    };

    /* `tr:form-change` ne bulle pas : l'écoute est posée sur le formulaire. */
    #onFormChange = (event) => {
      if (event.detail === undefined) return;
      this.#applyForm(event.detail);
    };

    #syncFromForm = () => {
      const form = this.#form;
      if (form === null || typeof form.currentTotal !== 'number') return;

      const items = typeof form.getItems === 'function' ? form.getItems() : [];
      const single = items.length === 1 && Number(items[0].id) === Number(form.variantId);

      this.#applyForm({
        total: form.currentTotal,
        quantity: single ? items[0].quantity : 1,
        multi: single === false,
      });
    };

    #applyForm(detail) {
      this.#total = Number(detail.total) || 0;
      this.#quantity = Math.max(1, Number(detail.quantity) || 1);
      this.#multi = detail.multi === true;
      this.#render();
    }

    #render() {
      const follow = this.#follow && this.#total !== null;
      const total = follow ? this.#total : this.#unitPrice;
      const quantity = follow ? this.#quantity : 1;

      /* Référence = compare_at réel, sinon prix plein (utile seulement si une
         remise réellement configurée a abaissé le total). Jamais fabriquée. */
      const reference = Math.max(this.#unitCompare, this.#unitPrice) * quantity;
      const onSale = follow
        ? this.#multi === false && reference > total
        : this.#unitCompare > this.#unitPrice;
      const compare = follow ? reference : this.#unitCompare;

      this.classList.toggle('tr-price--on-sale', onSale);

      const current = this.querySelector('[data-ref="priceCurrent"]');
      if (current !== null) {
        current.textContent =
          this.#available === false && this.dataset.hideSoldOut === 'true'
            ? this.dataset.stringSoldOut ?? ''
            : this.#money(total);
      }

      const compareNode = this.querySelector('[data-ref="priceCompare"]');
      if (compareNode !== null) {
        compareNode.hidden = onSale === false;
        compareNode.textContent = onSale ? this.#money(compare) : '';
      }

      const saved = this.querySelector('[data-ref="priceSaved"]');
      if (saved === null) return;

      saved.hidden = onSale === false;
      if (onSale === false) return;

      const amount = compare - total;
      saved.textContent =
        this.dataset.savedFormat === 'amount'
          ? `${this.dataset.savedPrefix ?? ''} ${this.#money(amount)}`.trim()
          : `−${Math.round((amount * 100) / compare)} %`;
    }
  }

  if (customElements.get('tr-product-price') === undefined) {
    customElements.define('tr-product-price', TrProductPrice);
  }
  } catch(e) { console.error(e); }
})();

})();
